"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const auth0_react_1 = require("@auth0/auth0-react");
const connected_react_router_1 = require("connected-react-router");
const react_redux_1 = require("react-redux");
const config_1 = require("config");
const store_1 = __importDefault(require("store"));
const browserHistory_1 = __importDefault(require("../../services/browserHistory"));
const Routes_1 = __importDefault(require("./Routes"));
function App() {
    return ((0, jsx_runtime_1.jsx)(auth0_react_1.Auth0Provider, { audience: config_1.REACT_APP_ALPHAEON_MERCHANT_MUX_API, clientId: config_1.REACT_APP_AUTH0_ADMIN_CLIENTID, domain: config_1.REACT_APP_AUTH0_DOMAIN, redirectUri: (0, config_1.makePath)(config_1.APPLICATION_ROOT_URL, config_1.PATH.ADMIN), onRedirectCallback: onRedirectCallback, leeway: 60, children: (0, jsx_runtime_1.jsx)(react_redux_1.Provider, { store: store_1.default, children: (0, jsx_runtime_1.jsx)(connected_react_router_1.ConnectedRouter, { history: browserHistory_1.default, children: (0, jsx_runtime_1.jsx)(Routes_1.default, {}) }) }) }));
}
exports.default = App;
const onRedirectCallback = (appState) => {
    // Use the router's history module to replace the url
    browserHistory_1.default.replace(appState?.returnTo || window.location.pathname, appState);
};
